var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsMastercard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6801 3.60077H16.6992V26.3976H30.6801V3.60077Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1384 15.0009C18.1349 10.5532 20.1801 6.35082 23.6847 3.60471C17.7309 -1.0665 9.18104 -0.386096 4.04369 5.16775C-1.09366 10.7216 -1.09366 19.2842 4.04369 24.8381C9.18104 30.3919 17.7309 31.0723 23.6847 26.4011C20.179 23.6541 18.1337 19.4501 18.1384 15.0009Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7934 24.4008V23.5889H45.9951V23.421H45.5151V23.5889H45.7047V24.4008H45.7934ZM46.7252 24.4008V23.421H46.58L46.4106 24.1209L46.2412 23.421H46.0959V24.4008H46.2008V23.6589L46.3581 24.2959H46.4671L46.6244 23.6589V24.4008H46.7252ZM47.181 15.0007C47.181 20.5511 44.0063 25.6143 39.0054 28.0398C34.0046 30.4653 28.0555 29.8274 23.6848 26.3969C27.1879 23.6484 29.2333 19.4466 29.2333 14.9987C29.2333 10.5507 27.1879 6.3489 23.6848 3.60045C28.0555 0.169959 34.0046 -0.468004 39.0054 1.95751C44.0063 4.38303 47.181 9.44619 47.181 14.9966V15.0007Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsMastercard);
export default __webpack_public_path__ + "static/media/rewards-mastercard.6880f26718c0496835f6cd2025981ad6.svg";
export { ForwardRef as ReactComponent };